module.exports = __webpack_public_path__ + "static/ivan-87f722859a637364ab7ed34fb869f7ac.jpg";